angular.module("app").controller("GamesSwitchSkinsPageController", [
    '$scope',
    'preloadedGameData',
    'preloadedSkinsList',
    'casinoGameService',
    'errorHandler',
    'logger',
    function ($scope, preloadedGameData, preloadedSkinsList, casinoGameService, errorHandler, logger) {
        $scope.allQuery = "";
        $scope.existingQuery = "";
        $scope.gameData = angular.copy(preloadedGameData);
        $scope.skinsList = angular.copy(preloadedSkinsList.skins);

        $scope.add = function (initial) {
            $scope.gameData.skins.push({name: initial.name, id: initial.id})
        };

        $scope.remove = function (id) {
            for (var i = 0, l = $scope.gameData.skins.length; i < l; i++) {
                if ($scope.gameData.skins[i].id === id) {
                    return $scope.gameData.skins.splice(i, 1)
                }
            }
        };

        $scope.filterForAdd = function (skin) {
            var item  = getItemFromList($scope.allQuery, [skin]);
            return (item || item === null) && (!function () {
                    for (var i = 0, length = $scope.gameData.skins.length; i < length; i++) {
                        if ($scope.gameData.skins[i].id === skin.id) {
                            return true
                        }
                    }
                    return false
                }())
        };

        $scope.filterForRemove = function (skin) {
            var item  = getItemFromList($scope.existingQuery, [skin]);
            return (item || item === null)
        };

        $scope.save = function () {

            var requestData = {switchSkinsForGame: {game_id: $scope.gameData.id, skin_ides: []}},
                preloadedArray = [];
            for (var i = 0, l = $scope.gameData.skins.length; i < l; i++) {
                !!$scope.gameData.skins[i].id && requestData.switchSkinsForGame.skin_ides.push($scope.gameData.skins[i].id)
            }

            for (i = 0, l = preloadedGameData.skins.length; i < l; i++) {
                !!preloadedGameData.skins[i].id && preloadedArray.push(preloadedGameData.skins[i].id)
            }
            if (angular.equals(preloadedArray, requestData.switchSkinsForGame.skin_ides)) {
                return logger.logError("Nothing to update")
            }
            casinoGameService.switchSkins(requestData).then(
                function (response) {
                    if (response.status === 'ok') {
                        logger.logSuccess("updated");
                        preloadedGameData.skins = angular.copy($scope.gameData.skins);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function getItemFromList (filterQuery, list) {
            if (!!filterQuery) {
                for (var i = 0, length = list.length, regex = new RegExp("^" + filterQuery); i < length; i++) {
                    if (regex.test(list[i].name) || regex.test(list[i].id)) {
                        return true
                    }
                }
            } else {
                return null
            }
            return false
        }
    }
]);